<template>
  <div class="d-flex flex-column h-100vh">
    <Header></Header>
    <router-view></router-view>
    <Contact v-if="isLogin"></Contact>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from "../components/Header/Header";
import Contact from "../components/Contact";
export default {
  components: { Header, Contact },
  computed: {
    ...mapState("user", ["isLogin"])
  },
  created() {
    this.$vuetify.theme.dark = false;
  }
};
</script>
